module.exports = __webpack_public_path__ + "img/bg_03.a1224a63.png";